import { SortDirection } from 'common/visualizations/vif';

export const withCustomSort = (
  sortToFollow: SortDirection,
  existingCustomSortConfig: {
    [x: string]: unknown;
  }[],
) => {
  return sortToFollow === 'customSort' && existingCustomSortConfig.length !== 0;
};
